var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64863 18.1293L5.60437 22.0277L1.78764 22.1084C0.646992 19.9928 0 17.5722 0 14.9999C0 12.5126 0.604922 10.1669 1.67719 8.10156H1.67801L5.07598 8.72453L6.56449 12.1021C6.25295 13.0104 6.08314 13.9854 6.08314 14.9999C6.08326 16.101 6.28271 17.156 6.64863 18.1293Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7382 12.1978C29.9105 13.1051 30.0003 14.0422 30.0003 14.9999C30.0003 16.0738 29.8874 17.1214 29.6723 18.1318C28.9421 21.5703 27.0341 24.5728 24.391 26.6975L24.3902 26.6967L20.1103 26.4783L19.5045 22.6969C21.2584 21.6684 22.629 20.0588 23.351 18.1318H15.3301V12.1978H23.468H29.7382Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3903 26.6967L24.3911 26.6975C21.8205 28.7637 18.5551 30 15.0004 30C9.28809 30 4.32162 26.8071 1.78809 22.1085L6.64908 18.1294C7.91582 21.5101 11.1771 23.9168 15.0004 23.9168C16.6438 23.9168 18.1834 23.4725 19.5046 22.697L24.3903 26.6967Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.574 3.45328L19.7147 7.43156C18.3474 6.57691 16.7311 6.0832 14.9996 6.0832C11.0897 6.0832 7.7674 8.60021 6.56412 12.1022L1.67758 8.10164H1.67676C4.1732 3.28846 9.2023 0 14.9996 0C18.6391 0 21.9762 1.29645 24.574 3.45328Z",
    fill: "#F14336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7ee9ae35.svg";
export { ForwardRef as ReactComponent };